import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['useStartTime', 'startOfWeek', 'endOfWeek', 'endOfWeek']);
  const modifyTimeUnitCfg = `modifyTimeUnitCfg(input: ${dataModify})`;

  return gql`
  mutation {
    ${modifyTimeUnitCfg} {
      id
    }
  }
`;
};
